// id для тестирования через testing-library
export const DATA_TEST_ID = 'subscribe-mobile-mountains';
// id для тестирования кнопки закрытия
export const BUTTON_DATA_TEST_ID = 'subscribe-mobile-mountains-button';
